import type { C1_AxisData } from "../types/C1_ModelTypes";

/** Converts PDF points to plan metres using the selected drawing scale. */
export function pdfBoundaryAxes(
  page: { width: number; height: number },
  scale: number,
  floorId: string,
): Omit<C1_AxisData, "id">[] {
  if (![page.width, page.height, scale].every(value => Number.isFinite(value) && value > 0))
    throw new Error("PDF-Seitengröße oder Maßstab ist ungültig.");
  const metersPerPoint = scale * 0.0254 / 72;
  const innerPositions = (length: number): [number, number] => {
    const first = Math.floor(length * .25 / 5) * 5;
    const last = Math.floor(length * .75 / 5) * 5;
    // Very small sheets still need two distinct axes.
    return first < last ? [first, last] : [length * .25, length * .75];
  };
  const [left, right] = innerPositions(page.width * metersPerPoint);
  const [top, bottom] = innerPositions(page.height * metersPerPoint);
  return [
    { kind: "v", pos: left },
    { kind: "v", pos: right },
    { kind: "h", pos: top },
    { kind: "h", pos: bottom },
  ].map(axis => ({ ...axis, kind: axis.kind as "v" | "h", floorId, locked: true, pdfBoundary: true }));
}
